module.exports = __webpack_public_path__ + "media/images/box-arrow-outside-663b66456418495d309e7c98b673aa12.svg";